// api/common/OrderHub.ts
import * as signalR from '@microsoft/signalr';
import { API_BASE_URL } from '../config';

/**
 * Minimal, direct SignalR client for OrderService's OrderHub (/hubs/orders)'s
 * `OnOrderStatusChanged` event — same proven, direct pattern MessagesHub.ts/InventoryHub.ts
 * use instead of SignalRServiceBase (see MessagesHub.ts's doc comment for why).
 */
export interface OrderStatusChangedPayload {
  orderId: string;
  orderNumber: string;
  previousStatus: string;
  newStatus: string;
  note?: string | null;
  at: string;
}

/** Connects and starts listening. Caller owns the connection — call `.stop()` on cleanup. */
export function connectOrderHub(
  accessToken: string,
  onStatusChanged: (payload: OrderStatusChangedPayload) => void
): signalR.HubConnection {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${API_BASE_URL}/hubs/orders`, { accessTokenFactory: () => accessToken })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection.on('OnOrderStatusChanged', onStatusChanged);

  connection.start().catch((err) => {
    console.error('[OrderHub] connection failed:', err);
  });

  return connection;
}
